<template>
  <a-layout-header class="bbs-header">
    <div class="container navbar">
      <div class="navbar-top">

        <!-- <nuxt-link :to="$t('prefix')" class="navbar-brand"> -->
        <div class="navbar-brand" @click="gotoPage">
          <img src="~static/image/logo.png" alt="Logo" class="navbar-logo" />
        </div>
        <!-- </nuxt-link> -->
        <div v-if="user.uid" @mouseover="showLogout" class="navbar-login" @mouseout.stop="showLogoutBtn=false">
          <!--          <div  class="navbar-login">-->
          <!--            <i class="iconfont iconicontouxiang"></i>-->
          <!--            <div class="userName">-->
          <!--              {{ $store.state.user.showName}}-->
          <!--              <div class="logout" v-show="showLogoutBtn" @click="logout" @mouseout.stop="showLogoutBtn=false">-->
          <!--                <div class="arrows"></div>-->
          <!--                {{$t('login.Logout')}}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

        </div>
        <a-button v-else class="navbar-login" @click="$store.dispatch('loginVisible', true)">
          <!--          <div style="display: flex">-->
          <!--            <i class="iconfont icondenglu" style="font-size: 18px;"></i>-->
          <!--            <div style="font-size: 14px;line-height: 25px">{{ $t('login.btn') }}</div>-->
          <!--          </div>-->


        </a-button>
        <a-radio-group class="navbar-locale" :value="$store.state.locale">
          <span @click="onLocaleChange('')">
            <a-radio-button value="zh_CN">CH</a-radio-button>
          </span>
          <span @click="onLocaleChange('en')">
            <a-radio-button value="en">EN</a-radio-button>
          </span>
        </a-radio-group>
      </div>

    </div>
  </a-layout-header>
</template>

<script>
  import Cookies from 'js-cookie'
  export default {
    name: 'bbs-navbar',
    data() {
      return {
        userShow: false,
        searchData: '',
        showLogoutBtn: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
      navs() {
        return this.$store.state.navs
      }
    },
    watch: {

    },
    mounted() {
    },
    methods: {
      gotoPage() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
          return
        } else {
          window.location.href = this.$t('prefix')
        }
      },
      logout() {
        this.$store.dispatch('logout').then(() => {
          window.location.reload();
        })
      },
      showLogout() {
        this.showLogoutBtn = true
        console.log(this.showLogoutBtn)
      },
      link(nav) {
        const me = this, { key: path } = nav

        if (path) {
          if (/^(https?:)/.test(path)) {
            return {
              href: path,
              target: '_blank'
            }
          }
          return {
            is: 'nuxt-link',
            to: me.$t('prefix') + path.replace('/', '')
          }
        }
        return {}
      },
      onLocaleChange(lang) {
        let path = this.$route.fullPath
        var reg = new RegExp("/en", "g");
        path = path.replace(reg, "");
        if (lang == 'en') {
          window.location.href = '/en' + path
        } else {
          window.location.href = path
        }
        console.log('跳转新页面')
        // const me = this;
        // me.$pushStat('PC-全局', '点击', '中文/英文按钮')
      },
      onMenuClick({ label }) {
        this.$pushStat('PC-全局', '点击', `顶部导航栏-${label}按钮`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #bc0b27;

    a {
      color: #fff;
    }
  }

  .bbs-header {
    top: 0;
    padding: 0;
    width: 100%;
    height: auto;
    z-index: 999;
    position: fixed;
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    // background: #0D51FF;
    //background-image: url("~static/image/navbar.png");
		background: linear-gradient(90deg, rgba(6,31,131,1) 0%, rgba(34,69,193,1) 100%);
		height: 85px;
				display: flex;
        align-items: center;

    .navbar {
      .navbar-top {
				line-height: 30px;
				text-align: right;
				display: flex;

        .navbar-brand {
          float: left;
          margin-right: 20px;

          .navbar-logo {
            height: 30px;
            width: 258px;
          }
        }

        &:before {
          left: 0;
          right: 0;
          top: 50px;
          content: "";
          position: absolute;
          //border-bottom: 1px solid white;
        }

        .navbar-login {
          position: relative;
          display: inline-block;
          color: white;
          padding: 0;
          border: none;
          font-size: 14px;
					margin-left: auto;
					font-size: 12px;
					margin-right: 25px;
					margin-left: auto;
          background: transparent;

          .userName {
            position: relative;
            display: inline-block;

            .logout {
              position: absolute;
              z-index: 9999;
              left: 50%;
              transform: translateX(-50%);
              top: 43px;
              color: #999999;
              text-align: center;
              width: 82px;
              height: 36px;
              background: #F5F8FC;
              border-radius: 4px;
              line-height: 36px;
              cursor: pointer;

              .arrows {
                position: absolute;
                width: 10px;
                height: 10px;
                background: #F5F8FC;
                transform: rotate(45deg) translateX(-50%);
                top: 0;
                left: 50%;
              }
            }
          }


          .nacbar-signin {
            width: 20px;
            height: 20px;
            margin-right: 5px;
            margin-top: -4px;
          }
        }

        .navbar-locale {
					font-size: 12px;
					font-weight: 400;
					display: flex;
					align-items: center;


					.ant-radio-button-wrapper {
						color: white;
						height: 20px;
						padding: 0 5px;
						line-height: 18px;
						border: 1px solid rgba(255,255,255,1);
						background-color: #2245C1;

						&.ant-radio-button-wrapper-checked {
							color: #0881B8;
							box-shadow: none;
							border-color: white;
							background-color: white;
						}
					}
					&>:first-child {
						.ant-radio-button-wrapper {
							border-radius: 10px 0 0 10px;
						}
					}
					&>:last-child {
						.ant-radio-button-wrapper {
							border-radius: 0 10px 10px 0;
						}
					}
        }
      }

      .navbar-bottom {
        height: 60px;
        line-height: 60px;
        position: relative;
        white-space: nowrap;
        transform: translateX(-18px);


        .navbar-nav {
          overflow: hidden;
          white-space: nowrap;
          display: flex;
          justify-content: space-between;

          .nav-menu {
            border: none;
            height: 60px;
            line-height: 60px;
            display: inline-block;
            background: transparent;

            .nav-item {
              top: 0;
              border: none;
              padding: 0 10px;
              margin: 0 5px;
              font-size: 18px;

              &.ant-menu-item-selected:after,
              &.ant-menu-submenu-selected:after {
                left: 15px;
                right: 15px;
                bottom: 0;
                content: "";
                position: absolute;
                border-bottom: 4px solid white;
              }

              ::v-deep {
                * {
                  color: white;
                }

                .ant-menu-submenu-title {
                  margin: 0 -10px;
                  padding: 0 10px;

                  &:hover {
                    background-color: #0045f4;
                  }
                }
              }
            }
          }
        }

        .navbar-btn {
          cursor: pointer;
          position: relative;
          display: flex;

          .searceh {
            position: relative;
            width: 220px;
            height: 32px;
            background: #0345EF;
            border: 1px solid #EEEEEE;
            border-radius: 16px;

            .iconsousuo {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 10px;
              color: #EEEEEE;
              font-size: 14px;
            }

            input {
              width: 100%;
              height: 100%;
              border: none;
              background: transparent;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              padding: 0 8px;
              padding-left: 27px;
              color: #fff;
            }
          }

          .nav-search {
            cursor: pointer;
            width: 18px;
            height: 18px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }

          .getinto {
            height: 36px;
            padding: 0 12px;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 1) !important;
            font-size: 17px;
            color: rgba(17, 31, 55, 1);
            line-height: 35px;
            text-align: center;
          }
        }
      }
    }
  }

  @media screen and(max-width: 1000px) {
    .navbar-logo {
      width: 190px !important;
      height: 24px !important;
    }
  }
</style>